import { LabeledInputDisplay } from "../../../shared/LabeledInput/LabeledInputDisplay.js";
import { SearchFilterUserActiveInactiveMultiSelect } from "../../../Users/shared/SearchFilterUserActiveInactiveMultiSelect.js";
import { SEARCH_FILTER_FILTER_LABELS } from "../../../shared/constants.js";
import { UserNames } from "../../../Users/shared/UserNames.js";
import { LocationLogEntryTypeNames } from "./LocationLogEntryTypeNames.js";
import { SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect } from "./SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect.js";
import { ActivityTypeTagTitles } from "../../../Tags/shared/ActivityTypeTagTitles.js";
import { SearchFilterActivityTypeMultiSelect } from "../../../Tags/shared/SearchFilterActivityTypeMultiSelect.js";
import { useState } from "react";
import { Modal } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntrySearchFiltersModal.tsx
function LocationLogEntrySearchFiltersModal({ filtersState, onClose, setFiltersState, showUsers = true, userRolesFilter }) {
	const [focusedFilter, setFocusedFilter] = useState();
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler: onClose,
		escPressClose: true,
		header: "Advanced Search Filters",
		outsideClickClose: true,
		children: /* @__PURE__ */ jsxs("div", {
			className: "gap-y-xs flex flex-col",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: classnames({
						"grid-cols-2": !showUsers,
						"grid-cols-3": showUsers
					}, "gap-x-xxs grid hover:cursor-pointer"),
					children: [
						/* @__PURE__ */ jsx("div", {
							onClick: () => {
								if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.ACTIVITY_TYPE) setFocusedFilter("");
								else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.ACTIVITY_TYPE);
							},
							children: /* @__PURE__ */ jsx(LabeledInputDisplay, {
								displayOnly: true,
								label: "Activity Types",
								nameElement: /* @__PURE__ */ jsx(ActivityTypeTagTitles, {
									activityTypeTagIds: filtersState.activityTypeIds || [],
									listAll: false
								}),
								value: filtersState.activityTypeIds
							})
						}),
						showUsers && /* @__PURE__ */ jsx("div", {
							onClick: () => {
								if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.AUTHOR) setFocusedFilter("");
								else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.AUTHOR);
							},
							children: /* @__PURE__ */ jsx(LabeledInputDisplay, {
								displayOnly: true,
								label: "Authors",
								nameElement: /* @__PURE__ */ jsx(UserNames, {
									userIds: filtersState.selectedUserIds || [],
									listAll: false
								}),
								value: filtersState.selectedUserIds
							})
						}),
						/* @__PURE__ */ jsx("div", {
							onClick: () => {
								if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.ENTRY_TYPE) setFocusedFilter("");
								else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.ENTRY_TYPE);
							},
							children: /* @__PURE__ */ jsx(LabeledInputDisplay, {
								displayOnly: true,
								label: "Entry Types",
								nameElement: /* @__PURE__ */ jsx(LocationLogEntryTypeNames, {
									entryTypeIds: filtersState.selectedEntryTypeIds || [],
									listAll: false
								}),
								value: filtersState.selectedEntryTypeIds
							})
						})
					]
				}),
				/* @__PURE__ */ jsx(SearchFilterActivityTypeMultiSelect, {
					focused: focusedFilter === SEARCH_FILTER_FILTER_LABELS.ACTIVITY_TYPE,
					onChange: (val) => setFiltersState({ activityTypeIds: val }),
					onClearSelection: () => {
						setFiltersState({ activityTypeIds: void 0 });
					},
					onClick: () => {
						if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.ACTIVITY_TYPE) setFocusedFilter("");
						else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.ACTIVITY_TYPE);
					},
					value: filtersState.activityTypeIds
				}),
				showUsers && /* @__PURE__ */ jsx(SearchFilterUserActiveInactiveMultiSelect, {
					focused: focusedFilter === SEARCH_FILTER_FILTER_LABELS.AUTHOR,
					label: "Authors",
					onChange: (val) => setFiltersState({ selectedUserIds: val }),
					onClearSelection: () => {
						setFiltersState({ selectedUserIds: void 0 });
					},
					onClick: () => {
						if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.AUTHOR) setFocusedFilter("");
						else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.AUTHOR);
					},
					rolesFilter: userRolesFilter,
					value: filtersState.selectedUserIds
				}),
				/* @__PURE__ */ jsx(SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect, {
					focused: focusedFilter === SEARCH_FILTER_FILTER_LABELS.ENTRY_TYPE,
					onChange: (val) => setFiltersState({ selectedEntryTypeIds: val }),
					onClearSelection: () => {
						setFiltersState({ selectedEntryTypeIds: void 0 });
					},
					onClick: () => {
						if (focusedFilter === SEARCH_FILTER_FILTER_LABELS.ENTRY_TYPE) setFocusedFilter("");
						else setFocusedFilter(SEARCH_FILTER_FILTER_LABELS.ENTRY_TYPE);
					},
					value: filtersState.selectedEntryTypeIds
				})
			]
		})
	});
}
//#endregion
export { LocationLogEntrySearchFiltersModal };

//# sourceMappingURL=LocationLogEntrySearchFiltersModal.js.map